"use strict";

import React, {Component} from "react";
import "react-table/react-table.css";

import Tabs from "../../component/Widget/Tabs";
import Section from "../../component/Template/Section";
import EnrichedVideoTable from "../../component/EnrichedVideo/Widget/EnrichedVideoTable";

import {filterContextToRequestParams, onFilterContextDidUpdate} from "../../context/FilterContext/Util";

import {apiPath} from "../../const";
import {getRequest} from "../../service/api/request";
import Box from "../../component/Widget/Box";
import PropTypes from "prop-types";
import _ from "lodash";

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;


class EnrichedVideosByViolation extends Component {

    static defaultProps = {
        defaultPageSize: 20,
        defaultSorted: [{id: "lastModifiedDate", desc: true}],
        defaultSortDesc: true,
    };

    constructor(props) {
        super(props);

        let filtered = [{ id: 'search', value: '' }];
        let filterContext = filterContextToRequestParams(props.filterContext);
        Object.keys(filterContext).forEach(filterContextKey => {
            if (!(filterContext[filterContextKey] instanceof Function))
                filtered.push({id: filterContextKey, value:filterContext[filterContextKey]});
        });

        this.state = {
            dataCountsByValidation: {},
            dataCountsBySubValidationByValidation: {},
            origData:{},
            search: '',
            filtered: filtered,
            loading: true,
            violationLevel: this.props.match.params.violationLevel,
        };
        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.onKeyDownSearch = this.onKeyDownSearch.bind(this);
    }

    componentWillMount() {
        this.searchTimeoutHandle = 0;
    }

    componentDidMount() {
        this.triggerSearch();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.violationLevel !== this.props.match.params.violationLevel) {
            this.setState({
                violationLevel: this.props.match.params.violationLevel,
                search: '',
                dataCountsByValidation: {},
                dataCountsBySubValidationByValidation: {},
                loading: false,
            }, () => {
                this.triggerSearch();
            });
            return;
        }

        onFilterContextDidUpdate(prevProps.filterContext,
                                 this.props.filterContext,
                                 () => {
                                     this.triggerSearch();
                                 });
    }

    fetchData() {
        this.setState({ loading: true });

        const { violationLevel, filtered } = this.state;

        const reportApiPath = apiPath + "/enrichedVideos/search/generateSummaryViolationReport";

        let params = {};
        filtered.forEach((filter) => {
            params[filter.id] = filter.value;
        });
        params["violationLevels"] = [ violationLevel ];

        getRequest(
            reportApiPath,
            params
        ).then(response => {
            this.setState({
                dataCountsByValidation: this.extractCountsByValidationByViolationLevel(response.entity, violationLevel),
                dataCountsBySubValidationByValidation: this.extractCountsBySubValidationByValidationByViolationLevel(response.entity, violationLevel),
                loading: false,
            });
        });
    }

    extractCountsByValidationByViolationLevel(violationReport, violationLevel) {
        switch (violationLevel) {
            case 'WARNING':
                return violationReport.warningCountsByValidation;
            case 'INFO':
                return violationReport.infoCountsByValidation;
            case 'UNKNOWN':
                return violationReport.unknownCountsByValidation;
            case 'ERROR':
            default:
                return violationReport.errorCountsByValidation;
        }
    }

    extractCountsBySubValidationByValidationByViolationLevel(violationReport, violationLevel) {
        switch (violationLevel) {
            case 'WARNING':
                return violationReport.warningCountsBySubValidationByValidation;
            case 'INFO':
                return violationReport.infoCountsBySubValidationByValidation;
            case 'UNKNOWN':
                return violationReport.unknownCountsBySubValidationByValidation;
            case 'ERROR':
            default:
                return violationReport.errorCountsBySubValidationByValidation;
        }
    }

    onChangeSearch(e) {
        const self = this;

        if (self.searchTimeoutHandle) {
            clearTimeout(self.searchTimeoutHandle);
        }

        const { value } = e.target;
        const search = value;
        this.setState({ search });

        self.searchTimeoutHandle = setTimeout(() => self.triggerSearch(), WAIT_INTERVAL)
    }

    onKeyDownSearch(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerSearch();
        }
    }

    triggerSearch() {
        const self = this;
        if (self.searchTimeoutHandle) {
            clearTimeout(self.searchTimeoutHandle);
        }

        const {search} = this.state;
        let filterContext = filterContextToRequestParams(this.props.filterContext);

        let filtered = [];

        if (search) filtered.push({ id: 'search', value: search });

        Object.keys(filterContext).forEach(filterContextKey => {
            if (!(filterContext[filterContextKey] instanceof Function))
                filtered.push({id: filterContextKey, value:filterContext[filterContextKey]});
        });

        this.setState({ filtered }, () => this.fetchData());
    }

    render() {
        const { dataCountsByValidation, dataCountsBySubValidationByValidation, search, filtered, violationLevel } = this.state;

        return (
            <div>
                <Section className="content-header">
                    <h1>Scheduled Enriched Videos <small>{this.renderAvailabilityHeader(violationLevel)}</small></h1>
                </Section>
                <Section className="content">
                    <div className="form-group">
                        <input id="search" type="text" className="form-control" placeholder="Search..."
                               value={search} onChange={this.onChangeSearch} onKeyDown={this.onKeyDownSearch} />
                    </div>
                    <Tabs tabs={this.renderValidationTabs(violationLevel, dataCountsByValidation, dataCountsBySubValidationByValidation, filtered)} />
                </Section>
            </div>
        );
    }

    renderAvailabilityHeader(violationLevel) {
        switch (violationLevel) {
            case 'WARNING':
                return "Available in Catalogue with Warnings";
            case 'INFO':
                return "Available in Catalogue with Info";
            case 'UNKNOWN':
                return "Available in Catalogue with Unknown Violations";
            case 'ERROR':
            default:
                return "Excluded from Catalogue with Errors";
        }
    }

    renderValidationTabs(violationLevel, dataCountsByValidation, dataCountsBySubValidationByValidation, filtered) {
        let tabs = {};

        Object.keys(dataCountsByValidation).sort().forEach(validation => {
            tabs[`${validation} (${dataCountsByValidation[validation]})`] = this.renderSubValidationGroups(violationLevel, validation, dataCountsBySubValidationByValidation[validation], filtered);
        });

        return tabs;
    }

    renderSubValidationGroups(violationLevel, validation, dataCountsBySubValidation, filtered) {
        return (
            <div key={`${validation}_content`} id={`${validation}_content`} className="tab-pane">
            {
                Object.keys(dataCountsBySubValidation).sort().map(subValidation =>
                    <Box key={`${validation}_${subValidation}`}
                         header={ subValidation ? `${subValidation} (${dataCountsBySubValidation[subValidation]})` : `` }
                         content={this.renderEnrichedVideoTable(violationLevel, validation, subValidation, filtered)}
                    />
                )
            }
            </div>
        );
    }

    renderEnrichedVideoTable(violationLevel, validation, subValidation, filtered) {
        return (
            <div key={`${subValidation}_content`} id={`${subValidation}_content`}>
                <GranularEnrichedVideoTable
                    filtered={filtered}
                    violationLevel={violationLevel}
                    validation={validation}
                    subValidation={subValidation}
                    />
            </div>
        );
    }
}

class GranularEnrichedVideoTable extends Component {

    static defaultProps = {
        defaultPageSize: 20,
        defaultSorted: [{id: "lastModifiedDate", desc: true}],
        defaultSortDesc: true,
    };

    static propTypes = {
        filtered: PropTypes.array.isRequired,
        violationLevel: PropTypes.string.isRequired,
        validation: PropTypes.string.isRequired,
        subValidation: PropTypes.string.isRequired,
        defaultPageSize: PropTypes.number,
        defaultSorted: PropTypes.array,
        defaultSortDesc: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            pages: null,
            loading: true,
            filtered: props.filtered,
            filterContext: props.filterContext,
            violationLevel: props.violationLevel,
            validation: props.validation,
            subValidation: props.subValidation,
        };

        this.onFetchData = this.onFetchData.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.filtered, this.props.filtered)) {
            this.setState({ filtered: this.props.filtered });
        }
    }

    onFetchData(state, instance) {
        this.setState({ loading: true });

        const enrichedVideosApiPath = apiPath + "/enrichedVideos/search/searchAllWithViolations";

        let params = {};
        params.size = state.pageSize;
        params.page = state.page;
        params.sort = state.sorted.map(sort => sort.id + "," + (sort.desc ? "desc" : "asc"));
        state.filtered.forEach((filter) => {
            params[filter.id] = filter.value;
        });
        const { violationLevel, validation, subValidation } = this.state;
        params.violationLevel = violationLevel;
        params.validation = validation;
        params.subValidation = subValidation;

        getRequest(
            enrichedVideosApiPath,
            params
        ).then(response => {
            const res = {
                data: response.entity._embedded.enrichedVideos,
                pages: response.entity.page.totalPages,
            };
            // Now just get the data of data to your React Table (and update anything else like total pages or loading)
            this.setState({
                data: res.data,
                pages: res.pages,
                loading: false,
            });
        });
    }

    render() {
        const { data, filtered, pages, loading } = this.state;
        const { defaultPageSize, defaultSorted, defaultSortDesc } = this.props;

        return (
            <EnrichedVideoTable
                manual={true} // Forces table not to paginate or sort automatically, so we can handle it server-side
                loading={loading} // Display the loading overlay when we need it
                data={data}
                filtered={filtered}
                pages={pages} // Display the total number of pages
                defaultPageSize={defaultPageSize}
                defaultSorted={defaultSorted}
                defaultSortDesc={defaultSortDesc}
                onFetchData={this.onFetchData} />
        );
    }
}

export default EnrichedVideosByViolation;
